const UPGRADE_POPUP_KEY = 'upgrade-popup-enabled';

export function isUpgradePopupEnabled(): boolean {
  const stored = localStorage.getItem(UPGRADE_POPUP_KEY);
  // Default is disabled (false) if not set
  if (stored === null) return false;
  return stored === 'true';
}

export function toggleUpgradePopup(): boolean {
  const current = isUpgradePopupEnabled();
  const next = !current;
  try {
    localStorage.setItem(UPGRADE_POPUP_KEY, String(next));
  } catch (e) {
    console.error('Failed to toggle upgrade popup state:', e);
    // If storage fails, keep the previous state
    return current;
  }
  return next;
}

export function setUpgradePopupEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(UPGRADE_POPUP_KEY, String(enabled));
  } catch (e) {
    console.error('Failed to set upgrade popup state:', e);
    // Optionally, you could fallback to a default or rethrow
  }
}
